export default "__VITE_ASSET__DDGfP438__"